<template>
  <ejs-dialog ref="formDialog" id="profiles-form" class="dialog-papirus" target="#dialogProfiles" :isModal="true"
    :visible="showing" :header="header" :width="width" :showCloseIcon="true" :close="onDialogClose" :open="onDialogOpen"
    z-index="1003">
    <div id="profileToast"></div>
    <div class="col-lg-12 e-input-section">
      <div class="content-wrapper">
        <div class="row">
          <div class="col-xs-12 col-sm-12 col-lg-10 col-md-12">
            <label class="e-text">Nombre Perfil</label>
            <input id="name" class="e-input" :class="{ 'e-warning': hasError('name') }" type="text" required
              v-model="m_data.name" :readonly="isFormReadOnly" @input="validateField('name')"
              @blur="validateField('name')" placeholder="Nombre Perfil" />
            <span class="help e-text small" :class="{ 'e-warning': hasError('name') }" v-text="m_errors.name">
            </span>
          </div>
          <div class="col-xs-12 col-sm-12 col-lg-2 col-md-12 control-section switch-control classEspecial"
            v-show="showId">
            <div>
              <ejs-switch cssClass="align-middle" id="active" v-model="m_data.active" :checked="m_data.active"
                :disabled="isFormReadOnly || !canDelete"></ejs-switch>
              <label for="active" class="e-text align-middle switch-label">{{
                m_data.active ? "Activo" : "Inactivo"
                }}</label>
            </div>
          </div>
        </div>
        <div class="row" v-if="showSaveButton">
          <div class="col-xs-12 col-sm-12 col-lg-10 col-md-6">
            <div>
              <label for="roleId" style="padding: 0px 40px 0px 0">Rol</label>
              <ejs-dropdownlist ref="roleDropDown" id="roleId" :dataSource="rolesList" :fields="fields"
                :readonly="isFormReadOnly" @change="roleDropDown_change" placeholder="Rol"></ejs-dropdownlist>
            </div>
          </div>
          <div class="e-btn-group col-xs-12 col-sm-12 col-lg-2 col-md-2 classEspecial">
            <ejs-button @click.native="addRole" :isPrimary="true" iconCss="e-icons icon-plus-circled inline-command"
              cssClass="e-flat e-noback">Agregar
            </ejs-button>
          </div>
        </div>
        <div class="row">
          <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
            <ejs-grid ref="gridRolesRef" class="r-space" :load="onGridLoad"
              :toolbarClick="toolbar_click" :actionBegin="onActionBegin" :toolbar="toolbar" :dataSource="gridData"
              :allowPaging="true" :pageSettings="pageSettings" locale="es-CO">
              <e-columns>
                <e-column field="id" headerText="Id Papirus" textAlign="Right" :width="90" :minWidth="90"
                  clipMode="Clip" :isPrimaryKey="true" :visible="false"></e-column>
                <e-column field="name" headerText="Rol" filter="Menu" :width="200" clipMode="EllipsisWithTooltip"
                  :required="true"></e-column>
                <e-column headerText="Acciones" AllowFiltering="false" :width="100" :commands="commandsRol">
                </e-column>
              </e-columns>
            </ejs-grid>
          </div>
        </div>
        <!-- <hr />
        <div class="row">
          <span class="e-icons icon-lock inline-command"></span>
          <h6>Vista Previa Accesos</h6>
          <ejs-treeview
            id="treeview"
            ref="treeObj"
            :fields="fields"
            :showCheckBox="true"
          ></ejs-treeview>
        </div> -->
        <div class="row pull-right">
          <div class="col-xs-12 col-sm-12">
            <div class="e-btn-group">
              <ejs-button @click.native="validateForm" :isPrimary="true" iconCss="e-icons icon-save inline-command"
                cssClass="e-flat e-noback" v-if="showSaveButton" :disabled="disableButtons">Grabar</ejs-button>
              <ejs-button :isDanger="true" iconCss="e-icons icon-trash inline-command"
                cssClass="e-flat e-danger e-noback" v-if="showDeleteButton" :disabled="disableButtons">Desactivar
              </ejs-button>
              <ejs-button @click.native="close()" iconCss="e-icons icon-cancel inline-command"
                cssClass="e-flat e-noback" :disabled="disableButtons">Cancelar</ejs-button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </ejs-dialog>
</template>

<script>
  export const RolesColumns = {
    COL_ID: 0,
    COL_NAME: 1,
    COL_BUTTONS: 2
  };

  import Vue from "vue";
  /*import { object, string, number, yup, when } from "yup";*/

  import { FormActionEnum } from "../../services/enums.js";
  import PermissionMixin from "../../mixins/PermissionMixin";
  import ToastMixin from "../../mixins/ToastMixin";
  import CultureMixin from "../../mixins/CultureMixin";

  /* Plugins de Syncfusion */
  import { Browser } from "@syncfusion/ej2-base";
  import { TreeViewPlugin } from "@syncfusion/ej2-vue-navigations";
  import { CheckBoxPlugin } from "@syncfusion/ej2-vue-buttons";
  import { ButtonPlugin } from "@syncfusion/ej2-vue-buttons";
  import { SwitchPlugin } from "@syncfusion/ej2-vue-buttons";
  import { DropDownListPlugin } from "@syncfusion/ej2-vue-dropdowns";
  import { NumericTextBoxPlugin } from "@syncfusion/ej2-vue-inputs";
  import { DialogPlugin } from "@syncfusion/ej2-vue-popups";
  import { TooltipPlugin, Tooltip } from "@syncfusion/ej2-vue-popups";

  /* Utilidades Syncfusion */
  import { DialogUtility } from "@syncfusion/ej2-popups";
  import {
    createSpinner,
    showSpinner,
    hideSpinner
  } from "@syncfusion/ej2-popups";

  import {
    GridPlugin,
    Edit,
    Page,
    CommandColumn,
    Toolbar
  } from "@syncfusion/ej2-vue-grids";

  /* Validación con YUP*/

  import * as Yup from "yup";
  import { es } from "yup-locales";
  import { setLocale } from "yup";
  setLocale(es);

  Vue.use(DialogPlugin);
  Vue.use(NumericTextBoxPlugin);
  Vue.use(ButtonPlugin);
  Vue.use(TreeViewPlugin);
  Vue.use(CheckBoxPlugin);
  Vue.use(SwitchPlugin);
  Vue.use(DropDownListPlugin);
  Vue.use(GridPlugin);
  Vue.use(TooltipPlugin);

  export default Vue.extend({
    mixins: [PermissionMixin, ToastMixin, CultureMixin],
    computed: {
      showId() {
        return this.formAction !== FormActionEnum.ADD;
      },
      showSaveButton() {
        return (
          this.formAction === FormActionEnum.ADD ||
          this.formAction === FormActionEnum.EDIT
        );
      },
      showDeleteButton() {
        return this.formAction == FormActionEnum.DELETE;
      },
      customClass() {
        return {
          "dialog-papirus": true,
          "dialog-edit":
            this.formAction == FormActionEnum.ADD ||
            this.formAction == FormActionEnum.EDIT,
          "dialog-view": this.formAction == FormActionEnum.VIEW,
          "dialog-delete": this.formAction == FormActionEnum.DELETE
        };
      },
      isFormReadOnly() {
        var ret = false;

        switch (this.formAction) {
          case FormActionEnum.ADD:
            break;
          case FormActionEnum.EDIT:
            break;
          case FormActionEnum.VIEW:
            ret = true;
            break;
          case FormActionEnum.DELETE:
            ret = true;
            break;
        }
        return ret;
      },
      header() {
        if (this.formAction === FormActionEnum.ADD) {
          return "Nuevo Perfil";
        }
        if (this.formAction === FormActionEnum.VIEW) {
          return "Consultar Perfil";
        }
        if (this.formAction === FormActionEnum.EDIT) {
          return "Modificar Perfil";
        }
        if (this.formAction === FormActionEnum.DELETE) {
          return "Deshabilitar Perfil";
        }
        return "";
      },
      rolesList() {
        let roles = this.$store.getters["roles/allRoles"];
        const newArray = JSON.parse(JSON.stringify(roles));
        // newArray.unshift({ id: "0", name: "-- seleccione -- " });
        return newArray.filter(function (rol) {
          return rol.active === true;
        });
      },
      canDelete() {
        if (!this.hasPermission("CanDelete")) {
          return false;
        }
        return true;
      },
      disableButtons() {
        return this.isSaving;
      }
    },
    data() {
      return {
        /* Datos del Componente*/
        isValid: false,
        isSaving: false,
        isMounted: false,
        validationSchema: {},
        m_errors: {},
        m_data: {},
        fields: { text: "name", value: "id" },
        gridData: [],
        toolbar: [],
        roleSelected: "",
        /* Datos del Dialogo de Syncfusion*/
        isModal: true,
        /*isOpen: false,*/
        target: document.getElementById("dialog"),
        width: this.isMobile ? "500px" : "70%",
        pageSettings: { pageCount: 5, pageSize: 10 },
        commandsRol: [
          {
            type: "Eliminar",
            buttonOption: {
              iconCss: "e-icons e-delete inline-command",
              cssClass: "e-flat e-noback",
              click: this.deleteTool_click
            }
          }
        ]
      };
    },
    created() { },
    async mounted() {
      try {
        //crear el spinner de loading

        createSpinner({
          target: this.$refs.formDialog.$el
        });
        await this.$store.dispatch("roles/getRoles");
        this.buildYupSchema();
        this.isMounted = true;
      } catch (error) {
        console.log(error);
      }
    },
    updated() {
      try {
        this.$refs.gridRolesRef.ej2Instances.dataSource = this.gridData;
        this.$refs.gridRolesRef.ej2Instances.refresh();
      } catch (error) {
        console.log(error);
      }
    },
    provide: {
      grid: [Edit, Page, CommandColumn, Toolbar, Tooltip]
    },
    methods: {
      onDialogOpen() {
        this.m_data = Object.assign({}, this.formData);
        this.cancelUnload = true;
        this.gridData = this.m_data.roles.filter(function (rol) {
          return rol.active === true;
        });
      },
      onDialogClose() {
        try {
          this.clearErrors();
          this.m_data = {
            id: 0,
            name: "",
            active: false,
            roles: [],
            application: {
              id: 0
            }
          };
          this.$emit("formClosed");
        } catch (error) {
          console.log(error);
        }
      },
      onGridLoad() {
        var isMobile = Browser.isDevice;
        if (isMobile) {
          try {
            this.toolbar = [
              {
                text: "Borrar",
                tooltipText: "Borrar Registro",
                prefixIcon: "e-delete",
                id: "deleteTool"
              }
            ];
          } catch (error) {
            console.log(error);
          }

          /*Ocultar la columnas en version móvil*/
          this.$refs.gridRolesRef.ej2Instances.columns[
            RolesColumns.COL_BUTTONS
          ].visible = false;
        }
      },
      onActionBegin: function (args) {
        if (args.requestType === "refresh") {
          this.$refs.gridRolesRef.showSpinner();
        }

        if (args.requestType == "delete") {
          args.cancel = true;
        }
      },
      onActionComplete: function (args) {
        if (args.requestType === "refresh") {
          this.$refs.gridRolesRef.hideSpinner();
        }
      },
      toolbar_click: function (args) {
        if (args.item.id === "deleteTool") {
          this.deleteTool_click();
        }
      },
      deleteTool_click(args) {
        if (this.formAction == FormActionEnum.VIEW) {
          this.showToast(
            "No habilitado",
            "Modo consulta, nada para grabar!",
            2000
          );
          return;
        }
        let rowData = null;
        if (args == undefined) {
          rowData = this.getRowDataFromToolbar();
        } else {
          rowData = this.getRowData(args);
        }

        let hasRowData = !!rowData;
        if (hasRowData) {
          //validar que exista
          rowData.active = false;
          this.getDeleteConfirmation(rowData);
        }
      },
      getRowDataFromToolbar() {
        var rows = this.$refs.gridRolesRef.ej2Instances.getSelectedRows()[0];
        if (!rows) {
          var dlg = this.getAlertDialog(
            "Seleccione Item",
            "No ha seleccionado ningún item"
          );

          dlg.show();
          return null;
        }

        let rowObj = this.$refs.gridRolesRef.ej2Instances.getRowObjectFromUID(
          rows.getAttribute("data-uid")
        );

        return rowObj.data;
      },
      getRowData: function (args) {
        /* Consultar los datos si le dan Doble click al grid */
        if (args.type === "actionBegin" && args.requestType === "beginEdit") {
          return args.rowData;
        }

        /* Determinar a que fué que le dieron click, si a la etiqueta o al botón.*/
        var target = args.target;
        /* Si la etiqueta tiene la clase e-edit, es el label y no el botón (Validar si mejor se agrega otra clase) */
        if (target.classList.contains("inline-command")) {
          target = target.parentElement;
        }

        /*Después de tener identificado el Target, entonces buscamos la fila seleccionada */
        let rowObj = this.$refs.gridRolesRef.ej2Instances.getRowObjectFromUID(
          target.parentElement.parentElement.parentElement.getAttribute(
            "data-uid"
          )
        );
        //setear los datos.
        return rowObj.data;
      },
      getDeleteConfirmation(row) {
        this.deleteDialog = DialogUtility.confirm({
          title: "Eliminar Rol",
          content: `Confirma que desea quitar el rol: ${row.name}`,
          okButton: {
            text: "Eliminar",
            click: this.DeleteRow,
            isPrimary: true
          },
          zIndex: 1010,
          cancelButton: { text: "Cancelar" },
          showCloseIcon: false,
          closeOnEscape: false,
          animationSettings: { effect: "Zoom" }
        });
        this.deleteDialog.data = row;
        this.deleteDialog.show();
      },
      async DeleteRow() {
        try {
          var localData = JSON.parse(JSON.stringify(this.deleteDialog.data));

          this.gridData = this.gridData.filter(function (rol) {
            return rol.id != localData.id;
          });

          this.showToast(
            "Confirmación",
            `Rol ${localData.name}  Eliminado`,
            2000
          );
        } catch (error) {
          console.log(error);
        }
        this.deleteDialog.data = {};
        this.deleteDialog.hide();
      },
      close() {
        this.$emit("formClosed");
      },
      getAlertDialog(title, content) {
        let dialog = DialogUtility.alert({
          title: title,
          zindex: 1010,
          content: content,
          showCloseIcon: true,
          closeOnEscape: true,
          animationSettings: { effect: "Zoom" }
        });
        return dialog;
      },
      showSpinner() {
        showSpinner(this.$refs.formDialog.$el);
      },
      hideSpinner() {
        hideSpinner(this.$refs.formDialog.$el);
      },
      clearErrors() {
        this.m_errors = {};
      },
      async saveData() {
        try {
          this.isSaving = true;
          this.showSpinner();
          switch (this.formAction) {
            case FormActionEnum.VIEW:
              this.showToast(
                "No habilitado",
                "Modo consulta, nada para grabar!",
                2000
              );
              break;
            case FormActionEnum.ADD:
              this.m_data.roles = this.gridData;
              this.m_data.isActive = true;
              await this.$store.dispatch("profiles/createProfile", this.m_data);

              this.showToast("Confirmación", "Registro Creado!", 2000);
              break;
            case FormActionEnum.EDIT:
              this.m_data.roles = this.gridData;
              await this.$store.dispatch("profiles/updateProfile", {
                id: this.m_data.id,
                profile: JSON.parse(JSON.stringify(this.m_data))
              });
              this.showToast("Confirmación", "Registro Actualizado", 2000);
              break;
          }
          await this.$store.dispatch("profiles/getProfiles");
          /* esperar medio segundo antes de cerrar */
          setTimeout(() => {
            this.isSaving = false;
            this.hideSpinner();
            this.close();
          }, 500);
        } catch (error) {
          this.isSaving = false;
          this.hideSpinner();
          this.showToast(
            "Error!",
            "Ocurrió un error al ejecutar la operación",
            2000
          );
        }
      },
      buildYupSchema() {
        /*Hack para esLint*/

        this.validationSchema = Yup.object().shape({
          isNew: Yup.boolean(),
          name: Yup.string().required().max(50).label("Perfil")
        });
      },
      hasError(field) {
        return !!this.m_errors[field];
      },
      async validateField(field) {
        Vue.set(this.m_errors, field, "");

        if (this.isFormReadOnly) return;

        this.validationSchema.validateAt(field, this.m_data).catch((err) => {
          Vue.set(this.m_errors, err.path, err.message);
        });
      },
      async validateForm() {
        this.isValid = false;

        try {
          await this.validationSchema.validate(this.m_data, {
            abortEarly: false
          });
          if (this.gridData.length == 0) {
            this.showToast("Invalido", `Debe agregar almenos un rol`, 2000);
          } else {
            this.m_errors = {};
            /*Grabar los datos*/
            await this.saveData();
          }
        } catch (error) {
          error.inner.forEach((error) => {
            Vue.set(this.m_errors, error.path, error.message);
            //this.m_errors[error.path] = error.message;
          });
        }
      },
      roleDropDown_change(e) {
        this.roleSelected = e.itemData;
      },
      addRole() {
        var sel = !!this.roleSelected;
        if (!sel) return;

        if (
          this.gridData.find((element) => element.id === this.roleSelected.id)
        ) {
          this.showToast(
            "Invalido",
            `No puede agregar el rol ${this.roleSelected.name} nuevamente`,
            2000
          );
        } else {
          this.gridData.push({
            id: this.roleSelected.id,
            name: this.roleSelected.name
          });
        }
      }
    },

    props: {
      /** Whether the dialog is currently showing */
      showing: {
        type: Boolean,
        required: true,
        default: false
      },
      formAction: {
        type: Number,
        required: true,
        default: 0
      },
      isMobile: {
        type: Boolean,
        required: true,
        default: false
      },
      formData: {
        type: Object,
        required: false,
        default() {
          return { id: 0, name: "", active: 0, roles: [] };
        }
      }
    }
  });
</script>

<style scoped>
  @import url(../../../node_modules/@syncfusion/ej2-base/styles/fabric.css);
  @import url(../../../node_modules/@syncfusion/ej2-vue-buttons/styles/fabric.css);
  @import url(../form-icons.css);

  .classEspecial {
    align-self: center;
  }

  .dialog-papirus.e-dialog .e-dlg-header {
    color: #0078d6;
    font-size: 20px;
    font-weight: normal;
  }

  .content-wrapper div.row {
    padding: 5px 0px;
  }

  .switch-label {
    padding: 0px 0px 0px 20px;
    margin: auto;
    cursor: pointer;
  }

  .e-save.e-icons:before,
  .e-save.e-icons:before {
    content: "\e609";
  }

  @media only screen and (max-width: 480px) {
    .content-wrapper {
      width: 92%;
    }

    .e-input-section .col-xs-6,
    .e-input-section .col-xs-4,
    .e-input-section .col-xs-12 {
      padding: 10px 5px;
      width: 100%;
    }

    .content-wrapper div.row {
      padding: 0px;
    }
  }
</style>